import styled from '@emotion/styled';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { PerformanceName } from 'services/api/dashboard';
import DrawerLinkButton from './AheadLinkButton';

interface TitleLayoutProps extends HTMLAttributes<HTMLDivElement> {
  performanceName: PerformanceName;
}
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
function TitleLayout(props: PropsWithChildren<TitleLayoutProps>) {
  const { performanceName, children, ...rest } = props;
  return (
    <Container {...rest}>
      {children}
      <DrawerLinkButton performanceName={performanceName} />
    </Container>
  );
}
export default TitleLayout;
